import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../../firebase/AuthProvider';
import { Conversation } from '../../../services/chatService/ChatService';
import { GetExistingOrCretateMeetingAsync } from '../../../services/videoService/VideoService';
import { LobbyState } from '../../../interfaces/videocallDtos/videoCall';
import Loader from '../loader/Loader';
import AvatarImage from '../../ui/Avatar/AvatarImage'; // Using the new Avatar component
import videocallicon from '../../../assets/images/videocallicon.svg';
import backarrowwhitebtn from '../../../assets/images/backarrowwhitebtn.svg';
import { ValidateOtpResponseDto } from '../../../interfaces/ExtermalUserDtos/ExternalUsersDtos';
import { formatConversationTitle } from '../../../utilities/chat/conversationUtils';
import FeatureUnavailablePopup from '../../ui/FeatureUnavailablePopup/FeatureUnavailablePopup';
import ChatParticipantModal from './modals/ChatParticipantModal';
import { Button } from 'react-bootstrap';
import { faUsersViewfinder } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CiVideoOn } from "react-icons/ci";
import { HiOutlineUser } from "react-icons/hi2";


interface ChatHeaderProps {
    conversation: Conversation;
    handleChatClose?: () => void;
    singlePane?: boolean;
    isShowCallingIcon?: boolean;
    externalUserDetails?: ValidateOtpResponseDto | null
}

const VideoOn = CiVideoOn as any;
const User = HiOutlineUser as any;


const ChatHeader: React.FC<ChatHeaderProps> = ({ conversation, handleChatClose, singlePane, isShowCallingIcon = true, externalUserDetails = null }) => {
    const { currentUser } = useAuth(); // Assuming authToken is available from context
    const [callLoading, setCallLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const [showUsersModal, setShowUsersModal] = useState<boolean>(false);

    // Determine the other participant(s) to display their name and avatar
    const otherParticipants = conversation.participants.filter(p => p.id !== currentUser?.uid || externalUserDetails?.externalUserDetailId);
    const conversationTitle = conversation.channel?.name ? conversation.channel.name : formatConversationTitle(otherParticipants);

    // For 1-on-1 chats, we can show the other person's avatar
    const displayAvatarForId = otherParticipants.length === 1 ? otherParticipants[0].id : undefined;

    const handleClickVideoCall = async () => {
        const authToken = currentUser ? await currentUser?.getIdToken() : "";
        if (!conversation.id) return;
        // setCallLoading(true);
        try {
            const res = await GetExistingOrCretateMeetingAsync(authToken, null, conversation.id.toString());
            if (res.success) {
                const state: LobbyState = {
                    calenderEventId: null,
                    relatedChatConversationId: conversation.id.toString(),
                    isPublisher: res.data.isPublisher,
                    isOneToOneCall: conversation.participants.length == 2
                };
                navigate(`/lobby/${res.data.roomId}`, { state });
            } else {
                toast.error(res.message);
            }
        } catch (err: any) {
            toast.error(err.message);
        } finally {
            setCallLoading(false);
        }
    };


    const handleShowUsersModal = () => setShowUsersModal(true);
    const handleCloseUsersModal = () => setShowUsersModal(false);

    return (
        <>
            {/* {callLoading && <Loader />} */}
            <div className="chat_header">
                <div className="chat_header_left d-flex justify-start">
                    {singlePane && (
                        <button className="flex-shrink-0 mr-2" onClick={handleChatClose}>
                            <img src={backarrowwhitebtn} alt="Back" />
                        </button>
                    )}
                    <div className="chat_header_user">
                        <div className="chat_header_user_img">
                            {/* Use AvatarImage for a consistent look. Shows group icon if no specific user ID. */}
                            <AvatarImage size='sm' userId={displayAvatarForId || ""} />
                        </div>
                        <div className="chat_header_user_txt">
                            <h2 className="text_truncate" style={{ color: "#101828" }}>{conversationTitle}</h2>
                        </div>
                        <div>
                            <button className='flex gap-1 items-center rounded-[12px] bg-white px-2 py-1.5 font-medium text-[#747474]'
                                style={{ border: "1.2px solid #E5E7EB" }}
                                onClick={handleShowUsersModal}
                            >
                                <User className="text-lg text-[#252525]" />
                                {conversation?.participants?.length}
                            </button>
                            {/* <FontAwesomeIcon icon={faUsersViewfinder} size="lg" color="#101828" className='cursor-pointer' onClick={handleShowUsersModal}
                            /> */}

                        </div>
                    </div>
                </div>
                <div className="chat_header_right flex-shrink-0">
                    {
                        isShowCallingIcon &&

                        <div className="hover:bg-[#7e57c23b] p-2.5 cursor-pointer rounded-full" onClick={handleClickVideoCall}>
                            {/* <img
                                src={videocallicon}
                                alt="Video Call"
                                className="cursor-pointer"
                                onClick={handleClickVideoCall}
                            /> */}
                            <VideoOn className="#101828 text-3xl" />
                        </div>
                        // <FeatureUnavailablePopup message="Video call feature is not yet available in beta.">
                        // </FeatureUnavailablePopup>
                    }

                </div>
            </div>

            <ChatParticipantModal
                handleCloseUsersModal={handleCloseUsersModal}
                participants={conversation.participants}
                showUsersModal={showUsersModal}
            />
        </>
    );
};

export default ChatHeader;